export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-green-600 to-green-700 text-white py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <img
              src="https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/f05b5e34bf1a8c792548fd7132f5d18d.png"
              alt="Pavitra Rishta Logo"
              className="h-24 w-auto object-contain mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-sm text-white/90 leading-relaxed">
              Premium Sojat henna powder manufacturer and bulk supplier. Fresh crop, fine mesh quality for hair and mehndi use.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Products</h3>
            <ul className="space-y-2 text-sm text-white/90">
              <li>Henna Powder</li>
              <li>Mehndi Powder</li>
              <li>Henna Powder for Hair</li>
              <li>Natural Henna Powder</li>
              <li>Sojat Henna Powder</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-3 mt-1"></i>
                <p className="text-sm text-white/90">
                  Krishi Mandi, Sojat City, Rajasthan, Pali
                </p>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-lg mr-3"></i>
                <a href="tel:+919649408405" className="text-sm text-white/90 hover:text-white cursor-pointer">
                  +91 9649408405
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-whatsapp-line text-lg mr-3"></i>
                <a
                  href="https://wa.me/919649408405"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/90 hover:text-white cursor-pointer"
                >
                  +91 9649408405
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Social Media */}
            <div className="flex items-center space-x-4">
              <span className="text-sm font-semibold">Follow Us:</span>
              <a
                href="https://www.linkedin.com/in/shree-ram-trading-company-mehandi-powder-manufacturer-supplier-976845167"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/sojat_henna__bulk_manufacturer/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>

            {/* Copyright */}
            <p className="text-sm text-white/90">
              Copyright © {new Date().getFullYear()} Pavitra Rishta. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}